export default class Validation {
    constructor(raw = {}) {
        this.name = raw.name;
        this.courseName = raw.courseName;
        this.issuedDate = raw.issuedDate;
        this.integrityCheckAvailable = raw.integrityCheckAvailable;
        this.integrityValid = raw.integrityValid;
    }
}
